import {
  Dialog,
  DialogTitle,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  StyleRulesCallback,
  Theme,
  Typography,
  withStyles,
  WithStyles,
} from '@material-ui/core';
import * as React from 'react';
import deIcon from 'shared/de.png';
import enIcon from 'shared/en.png';
import { Languages } from '../shared/language/Language';
import Translator from './Translator';
import { RootState } from '../rootState';
import { selectCurrentLanguage } from '../modules/language';
import { connect } from 'react-redux';

type CssClasses = 'button';
const styles: StyleRulesCallback<CssClasses> = (theme: Theme) => ({
  button: {
    cursor: 'pointer',
  },
});

interface OwnProps {
  onLanguageChange: (language: Languages) => any;
}

interface StateProps {
  language: ReturnType<typeof selectCurrentLanguage>;
}

type Props = OwnProps & StateProps;

interface State {
  dialogOpen: boolean;
}

class LanguageSelection extends React.PureComponent<Props & WithStyles<CssClasses>, State> {
  state = {
    dialogOpen: false,
  };

  onLanguageSelection = () => {
    this.setState({ dialogOpen: true });
  };

  onCloseSelection = () => {
    this.setState({ dialogOpen: false });
  };

  changeToGerman = () => {
    this.setState({ dialogOpen: false });
    this.props.onLanguageChange('de');
  };

  changeToEnglish = () => {
    this.setState({ dialogOpen: false });
    this.props.onLanguageChange('en');
  };

  render() {
    const { classes, language } = this.props;
    return (
      <Translator>
        {translate => (
          <>
            <div onClick={this.onLanguageSelection} className={classes.button}>
              {language === 'de' && (
                <>
                  <Typography>
                    <img src={deIcon}/> {translate('german')}
                  </Typography>
                </>
              )}
              {language === 'en' && (
                <>
                  <img src={enIcon}/> {translate('english')}
                </>
              )}
            </div>
            <Dialog
              aria-labelledby="language-dialog-title"
              open={this.state.dialogOpen}
              onClose={this.onCloseSelection}
            >
              <DialogTitle id="language-dialog-title">{translate('selectLanguage')}</DialogTitle>
              <MenuList>
                <MenuItem selected={language === 'de'} onClick={this.changeToGerman}>
                  <ListItemIcon>
                    <img src={deIcon}/>
                  </ListItemIcon>
                  <ListItemText inset primary={translate('german')}/>
                </MenuItem>
                <MenuItem selected={language === 'en'} onClick={this.changeToEnglish}>
                  <ListItemIcon>
                    <img src={enIcon}/>
                  </ListItemIcon>
                  <ListItemText inset primary={translate('english')}/>
                </MenuItem>
              </MenuList>
            </Dialog>
          </>
        )}
      </Translator>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  language: selectCurrentLanguage(state),
});

export default connect(mapStateToProps)(withStyles(styles)(LanguageSelection));



// WEBPACK FOOTER //
// ./src/components/LanguageSelection.tsx